<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("branch")}}</h4>
                <p class="text-subtitle-1">{{$t("create_new_branch")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <BranchForm ref="form" v-model="data"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn block color="primary" @click="onSave" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    {{$t("save_btn")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn block depressed @click="onCancel">
                    {{$t("cancel_btn")}}
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-bind="alert" v-model="alert.display"/>
    </div>
</template>

<script>
import BranchForm from './../../components/Sales/BranchForm.vue';
import PAlert from '../../components/common/PAlert.vue';
import branch from '../../services/sales/branch';
import {fetchDpk} from './../../services/sales/dpk';
export default {
    components: {
        BranchForm,
        PAlert
    },
    data() {
        return {
            data: {},
            alert: {
                display: false,
                content: "Are you sure?",
                callback: null
            },
            loading: false,
            dpk: null
        }
    },
    methods: {
        onSave() {
            this.alert = { ...this.alert, display: true, content: this.$t("are_you_sure_you_want_to_save"), callback: this.save };
        },
        save() {
            if(!this.$refs.form.$refs.form.validate()) return;
            this.loading = true;
            branch.create({...this.data, dpk: this.dpk}).then(res => {
                this.$router.replace({
                    name: "BranchDisplay",
                    params: {
                        id: res.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        },
        onCancel() {
            this.alert = { ...this.alert, display: true, content: this.$t("are_you_sure_cancel"), callback: this.cancel };
        },
        cancel() {
            this.$router.back();
        }
    },
    async created() {
        this.dpk = (await fetchDpk()).data.key;
    }
}
</script>

<style>

</style>